import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class FacebookInteractionTrackingEvent extends BasicTrackingEvent {

    private _playerId: number;
    private _senderPlayerId: number;
    private _senderInstanceId: number;
    private _senderNetworkId: number;
    private _senderGameId: number;
    private _senderZoneId: number;
    private _senderFacebookId: string;
    private _senderLevel: number;

    private _receiverPlayerId: number;
    private _receiverInstanceId: number;
    private _receiverNetworkId: number;
    private _receiverGameId: number;
    private _receiverZoneId: number;
    private _receiverFacebookId: string;
    private _receiverLevel: number;

    private _stateId: number;
    private _openGraphObjectId: string;
    private _openGraphActionType: string;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};
        vars.playerId = this._playerId;
        vars.sender_player_id = this._senderPlayerId;
        vars.sender_instance_id = this._senderInstanceId;
        vars.sender_network_id = this._senderNetworkId;
        vars.sender_game_id = this._senderGameId;
        vars.sender_zone_id = this._senderZoneId;
        vars.sender_level = this._senderLevel;

        vars.state = this._stateId;
        vars.sender_facebook_id = this._senderFacebookId;
        vars.receiver_facebook_id = this._receiverFacebookId;

        // optional fields
        if (this._receiverPlayerId !== 0) {
            vars.receiver_player_id = this._receiverPlayerId;
        }
        if (this._receiverInstanceId !== 0) {
            vars.receiver_instance_id = this._receiverInstanceId;
        }
        if (this._receiverNetworkId !== 0) {
            vars.receiver_network_id = this._receiverNetworkId;
        }
        if (this._receiverGameId !== 0) {
            vars.receiver_game_id = this._receiverGameId;
        }
        if (this._receiverZoneId !== 0) {
            vars.receiver_zone_id = this._receiverZoneId;
        }
        if (this._receiverLevel !== 0) {
            vars.receiver_level = this._receiverLevel;
        }
        if (this._openGraphObjectId) {
            vars.open_graph_object_id = this._openGraphObjectId;
        }
        if (this._openGraphActionType) {
            vars.open_graph_action_type = this._openGraphActionType;
        }
        return vars;
    }

    public set senderPlayerId(value: number) {
        this._senderPlayerId = value;
    }

    public set senderInstanceId(value: number) {
        this._senderInstanceId = value;
    }

    public set senderNetworkId(value: number) {
        this._senderNetworkId = value;
    }

    public set senderGameId(value: number) {
        this._senderGameId = value;
    }

    public set senderZoneId(value: number) {
        this._senderZoneId = value;
    }

    public set senderFacebookId(value: string) {
        this._senderFacebookId = value;
    }

    public set senderLevel(value: number) {
        this._senderLevel = value;
    }

    public set receiverPlayerId(value: number) {
        this._receiverPlayerId = value;
    }

    public set receiverInstanceId(value: number) {
        this._receiverInstanceId = value;
    }

    public set receiverNetworkId(value: number) {
        this._receiverNetworkId = value;
    }

    public set receiverGameId(value: number) {
        this._receiverGameId = value;
    }

    public set receiverZoneId(value: number) {
        this._receiverZoneId = value;
    }

    public set receiverFacebookId(value: string) {
        this._receiverFacebookId = value;
    }

    public set receiverLevel(value: number) {
        this._receiverLevel = value;
    }

    public set stateId(value: number) {
        this._stateId = value;
    }

    public set openGraphObjectId(value: string) {
        this._openGraphObjectId = value;
    }

    public set openGraphActionType(value: string) {
        this._openGraphActionType = value;
    }

    public set playerId(value: number) {
        this._playerId = value;
    }
}
